import { useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowRight, Loader2, RotateCcw, ShoppingBag, TrendingUp } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const googleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const highlights = [[ShoppingBag, "7 marketplaces, one order feed"], [RotateCcw, "RTO & return tracking with claims"], [TrendingUp, "Daily profit & loss, settled payouts"]];

function BrandPanel() {
  return <aside className="auth-brand"><div className="brand"><div className="brand-mark">ep</div><div><strong>EcomPulse</strong><small>OPERATIONS OS</small></div></div><div className="auth-pitch"><p className="eyebrow">FOR INDIAN SELLERS</p><h1>Har order, har return, har rupaya — ek dashboard mein.</h1><ul>{highlights.map(([Icon, text]) => <li key={text}><Icon size={16} />{text}</li>)}</ul></div><div className="auth-channels">{["Amazon", "Flipkart", "Meesho", "Myntra", "Snapdeal", "Shopify", "WooCommerce"].map((m) => <span key={m}>{m}</span>)}</div></aside>;
}

export default function Login() {
  const { setUser } = useAuth();
  const location = useLocation();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState(location.state?.error || "");
  const [busy, setBusy] = useState(false);
  const field = (key) => ({ value: form[key], onChange: (e) => setForm({ ...form, [key]: e.target.value }) });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const body = mode === "login" ? { email: form.email, password: form.password } : form;
      const { data } = await api.post(`/auth/${mode}`, body);
      setUser(data);
    } catch (err) {
      setError(apiError(err));
    } finally { setBusy(false); }
  };

  return <div className="auth-shell"><BrandPanel /><main className="auth-main"><form data-testid="auth-form" className="auth-card" onSubmit={submit}>
    <p className="eyebrow">{mode === "login" ? "WELCOME BACK" : "CREATE WORKSPACE"}</p>
    <h2>{mode === "login" ? "Sign in to your seller workspace" : "Start managing your channels"}</h2>
    <div className="auth-tabs"><button type="button" data-testid="auth-tab-login" className={mode === "login" ? "active" : ""} onClick={() => setMode("login")}>Login</button><button type="button" data-testid="auth-tab-register" className={mode === "register" ? "active" : ""} onClick={() => setMode("register")}>Register</button></div>
    {mode === "register" && <label>Full name<input data-testid="auth-name-input" required {...field("name")} placeholder="Arjun Kapoor" /></label>}
    <label>Email<input data-testid="auth-email-input" type="email" required {...field("email")} placeholder="you@store.in" /></label>
    <label>Password<input data-testid="auth-password-input" type="password" required minLength={6} {...field("password")} placeholder="••••••••" /></label>
    {error && <div data-testid="auth-error" className="auth-error">{error}</div>}
    <button data-testid="auth-submit-button" className="dark-button auth-submit" disabled={busy}>{busy ? <Loader2 size={15} className="spin" /> : <ArrowRight size={15} />}{mode === "login" ? "Sign in" : "Create account"}</button>
    <div className="auth-divider"><span>or</span></div>
    <button type="button" data-testid="google-login-button" className="outline-button auth-google" onClick={googleLogin}><span className="g-logo">G</span>Continue with Google</button>
  </form></main></div>;
}
